module.exports = __webpack_public_path__ + "static/media/shequ-title-6.cab0fcb4.png";